import React from 'react';

import { IconProps } from './type';

export function CheckedIcon({
  className = '',
  size = 24,
  ...props
}: React.ComponentProps<'svg'> & IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M25 12.4997C25 13.5501 24.3406 14.4236 23.7027 15.2682C23.32 15.7754 22.9583 16.2546 22.7542 16.7467C22.5375 17.2694 22.4432 17.913 22.3526 18.5352C22.202 19.5653 22.0466 20.631 21.3387 21.3385C20.6312 22.0461 19.5658 22.2014 18.5357 22.3521C17.9134 22.443 17.2699 22.537 16.7472 22.7537C16.2547 22.9578 15.7758 23.3195 15.2687 23.7025C14.4241 24.34 13.5506 24.9995 12.5002 24.9995C11.4495 24.9995 10.5763 24.34 9.73165 23.7025C9.22453 23.3195 8.7453 22.9578 8.25314 22.7537C7.73043 22.5369 7.0869 22.443 6.46465 22.3521C5.43415 22.2014 4.36884 22.0461 3.66128 21.3385C2.95373 20.631 2.79806 19.5653 2.64772 18.5352C2.5568 17.9129 2.46288 17.2694 2.24615 16.7467C2.04205 16.2546 1.68029 15.7754 1.29731 15.2682C0.659787 14.4236 0 13.5501 0 12.4997C0 11.4493 0.659787 10.5758 1.29731 9.73122C1.68031 9.22411 2.04205 8.74489 2.24615 8.25273C2.46288 7.73002 2.5568 7.08653 2.64772 6.46426C2.79806 5.43412 2.95371 4.36847 3.66128 3.66092C4.36886 2.95338 5.43418 2.79806 6.46465 2.64737C7.08693 2.55645 7.73043 2.46253 8.25314 2.24581C8.7453 2.0417 9.22453 1.67995 9.73165 1.29698C10.5763 0.659459 11.4494 0 12.5002 0C13.5506 0 14.4241 0.659432 15.2687 1.29698C15.7758 1.67995 16.2547 2.0417 16.7472 2.24581C17.2699 2.46253 17.9134 2.55645 18.5357 2.64737C19.5658 2.79803 20.6312 2.95335 21.3387 3.66092C22.0466 4.36847 22.202 5.43412 22.3526 6.46426C22.4432 7.08653 22.5375 7.73002 22.7542 8.25273C22.9583 8.74489 23.3201 9.22411 23.7027 9.73122C24.3406 10.5758 25 11.4493 25 12.4997Z"
        fill="currentColor"
      />
      <path
        d="M18.7157 10.6223L11.7306 17.6074C11.4402 17.8977 10.9694 17.8977 10.679 17.6074L6.28418 13.2126C5.99381 12.9222 5.99381 12.4514 6.28418 12.1611L7.35403 11.0912C7.64439 10.8009 8.11516 10.8009 8.40555 11.0912L11.2048 13.8905L16.5944 8.50098C16.8847 8.21061 17.3555 8.21061 17.6459 8.50098L18.7157 9.57081C19.0061 9.86117 19.0061 10.3319 18.7157 10.6223Z"
        fill="white"
      />
    </svg>
  );
}

export default CheckedIcon;
